import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "kv" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "caption" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "環境品質監測報告")
  ])
], -1)
const _hoisted_2 = { class: "sect1" }
const _hoisted_3 = { class: "ctx" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sectTitle" }, "歷年監測報告", -1)
const _hoisted_5 = { class: "reportCont" }
const _hoisted_6 = { class: "report" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa-brands fa-envira" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "pic" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(14, (i) => {
                return _createElementVNode("a", {
                  target: "_blank",
                  href: _ctx.getLink(115-i),
                  key: i
                }, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(115-i) + " 年度環境品質監測年度報告", 1)
                ], 8, _hoisted_7)
              }), 64))
            ]),
            _hoisted_9
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}